import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IStockIncompleteFormPostResponse,
  IStockIncompleteFormStockItemsPostBody,
} from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
export const useStockItemsPostAPI = () => {
  const [newUserId, setNewUserId] = useState<string>("");
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (stockData: IStockIncompleteFormStockItemsPostBody) => {
      dispatch(
        setLoading({
          key: "isStockInCompleteInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!stockData) {
          return;
        }
        await axios
          .post(`${INVENTORY_MODULE?.STOCK_ITEMS_POST_API?.baseURL}`, JSON.stringify(stockData), {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IStockIncompleteFormPostResponse>) => {
            if (res.data.status === true) {
              setNewUserId(res?.data?.data?.user_id);
              toast.success("Invetory Requested Successfully!");
            } else {
              // console.log("not created");
              toast.error("Cannot filled form.");
            }
            dispatch(
              setLoading({
                key: "isStockInCompleteInProgress",
                status: false,
              }),
            );
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isStockInCompleteInProgress",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (error) {
        dispatch(
          setLoading({
            key: "isStockInCompleteInProgress",
            status: false,
          }),
        );
        // Handle errors
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { newUserId, execute };
};
